import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ReservationCalendar from "./ReservationCalendar";
import { Calendar, Kanban, List } from "lucide-react";
import ReservationList from "./List";
import { useTheme } from "@/layout/ThemeProvider";
import Nav from "@/components/common/Nav.";
import ReservationKanban from "./ReservationKanban";

const ServiceReservations = () => {
  return (
    <Tabs className="p-5" defaultValue="list">
      <TabsList>
        <TabsTrigger value="list" className="cursor-pointer px-5">
          <List />
        </TabsTrigger>
        <TabsTrigger value="calendar" className="cursor-pointer px-5">
          <Calendar />
        </TabsTrigger>
        <TabsTrigger value="kanban" className="cursor-pointer px-5">
          <Kanban />
        </TabsTrigger>
      </TabsList>
      <TabsContent value="list">
        <ReservationList />
      </TabsContent>
      <TabsContent value="calendar">
        <ReservationCalendar />
      </TabsContent>
      <TabsContent value="kanban">
        <ReservationKanban />
      </TabsContent>
    </Tabs>
  );
};

export default ServiceReservations;
